import React, { PureComponent } from 'react';

import './footer.styl';
import logo from '../../../public/images/IW-Logo.jpg';
import * as AppActions from '../../modules/App/AppState';


class Footer extends PureComponent {

  constructor() {
    super();

    this.onFaqClick = this.onFaqClick.bind(this);
  }

  onFaqClick(evt) {
    evt.preventDefault();
    this.props.dispatch(AppActions.toggleFaq());
  }

  render() {

    const bgImage = { backgroundImage: 'url(' + logo + ')' };

    return (
      <div className="ifdw-footer clearfix">
        <div className="ifdw-footer--inner-wrapper right">
          <div><a href="http://www.iwkoeln.de/mittelschicht" target="_blank" className="ifdw-footer--link">Zur Studie</a></div>
          <div className="ifdw-footer--faq">Definitionen und Hintergrundinformationen unter <a className="ifdw-footer--link" onClick={this.onFaqClick} href="#">FAQ</a></div>

        </div>
        <div className="ifdw-footer--inner-wrapper left">
          <a href="http://www.iwkoeln.de" target="_blank" className="ifdw-footer--logo" style={bgImage}></a>
        </div>
      </div>
    )
  }
};

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/Footer/index.js
 **/